import { render, staticRenderFns } from "./VActionLogKeywordsTable.vue?vue&type=template&id=5602a5d1"
import script from "./VActionLogKeywordsTable.vue?vue&type=script&lang=js"
export * from "./VActionLogKeywordsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports